export class LocalMemoryStore {
    async getWallets() {
        return Promise.resolve([]);
    }
    getWalletsSync() {
        return [];
    }
    async saveWallet(_wallet) {
        return Promise.resolve();
    }
    async deleteWallet(_wallet) {
        return Promise.resolve();
    }
}

//# sourceMappingURL=LocalMemoryStore.js.map
